import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, Grid, Paper, Typography } from '@mui/material';

export const Unavailable: FC = () => {
  const { t } = useTranslation();

  return (
    <Grid>
      <Paper>
        <Box
          sx={{
            p: 5,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="h1">{t('pages.unavailable.title')}</Typography>
          <Typography variant="body1">
            {t('pages.unavailable.message')}
          </Typography>
          <Button variant="contained" onClick={() => window.location.reload()}>
            {t('pages.unavailable.retry')}
          </Button>
        </Box>
      </Paper>
    </Grid>
  );
};
